export default "__VITE_ASSET__VIWVkAxL__"